import React from "react";

export default function BannerCard({
    banner,
    onClick

}) {
    console.log(banner);
    return (
        <button
            className="banner-card"
            onClick={onClick}
        >
            <img
                src={`https://myd.montepio.org/${banner}`}
                alt={banner}
            />
        </button>
    );

}